import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Break from "../../../../src/docs/components/break";
import Zoom from 'react-reveal/Zoom';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import Blair from "../../../../src/docs/assets/profiles/Blair.jpg";
import Castillo from "../../../../src/docs/assets/profiles/Castillo.jpg";
import Daniel from "../../../../src/docs/assets/profiles/Daniel.jpg";
import Failoni from "../../../../src/docs/assets/profiles/Failoni.jpg";
import Farcher from "../../../../src/docs/assets/profiles/Farcher.jpg";
import Higgins from "../../../../src/docs/assets/profiles/Higgins.jpg";
import Hydzik from "../../../../src/docs/assets/profiles/Hydzik.jpg";
import Jones from "../../../../src/docs/assets/profiles/Jones.jpg";
import Kaye from "../../../../src/docs/assets/profiles/Kaye.jpg";
import Mcglynn from "../../../../src/docs/assets/profiles/Mcglynn.jpg";
import Newton from "../../../../src/docs/assets/profiles/Newton.jpg";
import Plimpton from "../../../../src/docs/assets/profiles/Plimpton.jpg";
import Qualters from "../../../../src/docs/assets/profiles/Qualters.jpg";
import Rabadi from "../../../../src/docs/assets/profiles/Rabadi.jpg";
import Anthony from "../../../../src/docs/assets/profiles/Anthony.jpg";
import Arrieta from "../../../../src/docs/assets/profiles/Arrieta.jpg";
import Dorman from "../../../../src/docs/assets/profiles/Dorman.jpg";
import Johnson from "../../../../src/docs/assets/profiles/Johnson.jpg";
import Keating from "../../../../src/docs/assets/profiles/Keating.jpg";
import Latta from "../../../../src/docs/assets/profiles/Latta.jpg";
import Martinez from "../../../../src/docs/assets/profiles/Martinez.jpg";
import Mccormick from "../../../../src/docs/assets/profiles/Mccormick.jpg";
import Tudor from "../../../../src/docs/assets/profiles/Tudor.jpg";
import Surace from "../../../../src/docs/assets/profiles/Surace.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Break,
  Zoom,
  OutboundLink,
  Blair,
  Castillo,
  Daniel,
  Failoni,
  Farcher,
  Higgins,
  Hydzik,
  Jones,
  Kaye,
  Mcglynn,
  Newton,
  Plimpton,
  Qualters,
  Rabadi,
  Anthony,
  Arrieta,
  Dorman,
  Johnson,
  Keating,
  Latta,
  Martinez,
  Mccormick,
  Tudor,
  Surace,
  React
};